<template>
  <div>
    <el-container>
      <el-header>运营工作台</el-header>
      <el-main>
        <div>
          <el-form :inline="true" :model="searchData" ref="searchData">
            <el-form-item prop="ids">
              <el-input v-model="searchData.page_id" placeholder="主页id"></el-input>
            </el-form-item>
            <el-form-item prop="account">
              <el-input v-model="searchData.page_name" placeholder="主页名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearch" icon="el-icon-search">查询</el-button>
              <el-button @click="handleReset('searchData')"  icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
           </el-form>
          <el-table
            :data="statisticsList"
            class="table-info"
            highlight-current-row
            >
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
             <el-table-column
              label="主页id"
              width="140"
              prop="page_id">
            </el-table-column>
              <el-table-column
              label="主页名称"
              prop="page_name">
            </el-table-column>
            <el-table-column
              label="任务配置总数"
              prop="task_config_num">
            </el-table-column>
            <el-table-column
              label="是否删除"
              prop="is_active">
              <template slot-scope="scope">
                 {{scope.row.is_delete == 1? "是":"否"}}
              </template>
            </el-table-column>
            <el-table-column
              label="是否活跃"
              prop="is_active">
              <template slot-scope="scope">
                 {{scope.row.is_active == 1? "活跃":"不活跃"}}
              </template>
            </el-table-column>
            <el-table-column
              prop="success_num"
              label="成功数">
            </el-table-column>
            <el-table-column
              label="失败数"
              prop="fail_num">
            </el-table-column>
            <el-table-column
              prop="delete_num"
              label="删除数">
            </el-table-column>
            <el-table-column
              prop="success_num_by_time"
              label="7天内成功数">
            </el-table-column>
            <el-table-column
              prop="fail_num_by_time"
              label="7天内失败数">
            </el-table-column>
            <el-table-column
              prop="delete_num_by_time"
              label="7天内删除数"
              >
            </el-table-column>
            <el-table-column
              prop="last_update_time"
              sortable
              width="160"
              label="最后一次更新时间">
            </el-table-column>
            <el-table-column
              prop="create_time"
              sortable
              width="160"
              label="创建时间">
            </el-table-column>
            <el-table-column
              prop="update_time"
              sortable
              width="160"
              label="更新时间">
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="text-center m-20">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="10"
              layout="total, prev, pager, next,sizes,jumper"
              :total="totalDataNum">
            </el-pagination>
          </div>
        </div>
        </el-main>
    </el-container>
  </div>
</template>
<script>
 import * as API from '@/api/common'
  export default {
    name: 'workbench',
    data() {
      return {
        currentPage:1,
        perPageCount:10,
        totalDataNum:0,
        statisticsList: [],
        multipleSelection: [],
        searchData: this.emptyData()
      };
    },
    components:{
    },
    mounted() {
      this.getTableData();
    },
    methods: {
      getTableData(){
        var param = Object.assign(this.searchData,{page:this.currentPage, size: this.perPageCount});
         API.handleGet(API.statistics.create, {'params':param}).then(res =>{
            if(res.code != 0) return this.$message(res.message);
            this.statisticsList = res.data;
            this.totalDataNum  = res.page.total;
        }) 
      },
      //查询操作
      async handleSearch(){
        this.currentPage=1;
        this.getTableData();
      },
      //查询重置
      handleReset(actionDrawerData){
        this.searchData = this.emptyData();
      },
      //分页
      handleSizeChange(val) {
        this.perPageCount = val;
        this.getTableData();
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getTableData();
      },
      emptyData(){
        return {
          page_id:'',
          page_name: '',
        }
      },
    }
  };
</script>
<style>
    .el-table__header{
     background: #f1f2f3;
    }
</style>
<style lang="scss" scoped>
  .el-header{
    background-color: rgb(249 249 249);
    line-height: 60px;
    text-align: left;
    border: 1px solid #eee;
  }
  .table-info{
    border:1px solid #eee;
    p{
      margin: 0;
    }
  }
</style>